import { render, staticRenderFns } from "./IconInfo.vue?vue&type=template&id=01ea52fc&scoped=true"
import script from "./IconInfo.vue?vue&type=script&lang=js"
export * from "./IconInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ea52fc",
  null
  
)

export default component.exports